module.exports = __webpack_public_path__ + "img/laptop-img.8e4aa6fd.png";